export default __webpack_public_path__ + "static/media/logo-tab-existing.228d42a7.svg";